import { render, staticRenderFns } from "./ProblemPartAdd.form.vue?vue&type=template&id=3a0e0bcd&"
import script from "./ProblemPartAdd.form.vue?vue&type=script&lang=js&"
export * from "./ProblemPartAdd.form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports